import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';
import axios from 'axios';
import toast from 'react-hot-toast';
import { useState } from 'react';
import { API_BASE_URL } from '../utils';

const schema = z.object({
  name: z.string().min(1, 'Name required'),
  rating: z.coerce.number().min(1, 'Rating required (1-5 stars)').max(5, 'Rating must be at most 5'),
  comment: z.string().min(1, 'Comment required'),
});

const ReviewForm = ({ onAdd, onClose }) => {
  const { register, handleSubmit, formState: { errors }, reset, setValue } = useForm({
    resolver: zodResolver(schema),
  });
  const [rating, setRating] = useState(0);

  const onSubmit = async (data) => {
    try {
      const res = await axios.post(`${API_BASE_URL}/reviews`, data);
      toast.success('Review submitted');
      onAdd(res.data);
      reset();
      setRating(0);
      onClose();
    } catch (err) {
      toast.error('Failed to submit review');
    }
  };

  // Update form value when rating changes
  const handleRatingChange = (newRating) => {
    setRating(newRating);
    setValue('rating', newRating);
  };

  return (
    <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-6 rounded-lg shadow-lg z-50 max-w-lg w-full max-h-[80vh] overflow-y-auto">
      <button
        onClick={onClose}
        className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
      >
        ✕
      </button>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <div>
          <input
            {...register('name')}
            placeholder="Name"
            className="border p-2 w-full rounded"
          />
          {errors.name && <p className="text-red-500 text-sm">{errors.name.message}</p>}
        </div>
        <div>
          <label className="block mb-1">Rating</label>
          <div className="flex">
            {[...Array(5)].map((_, i) => (
              <span
                key={i}
                className={`star ${i < rating ? 'filled' : ''}`}
                onClick={() => handleRatingChange(i + 1)}
              >
                ★
              </span>
            ))}
          </div>
          {errors.rating && <p className="text-red-500 text-sm">{errors.rating.message}</p>}
        </div>
        <div>
          <textarea
            {...register('comment')}
            placeholder="Comment"
            className="border p-2 w-full rounded"
          />
          {errors.comment && <p className="text-red-500 text-sm">{errors.comment.message}</p>}
        </div>
        <button type="submit" className="bg-primary-900 text-white px-4 py-2 rounded w-full">
          Submit
        </button>
      </form>
    </div>
  );
};

export default ReviewForm;